module.exports = __webpack_public_path__ + "img/icon-print.59df629d.svg";